
<form [formGroup]="searchForm" >
    <div>
        <input class="form-control-input with-icon caption" type="text" matInput [formControl]="dataItemSelector"  placeholder="{{ 'PLACEHOLDERS.DATA_FIELD' | translate }}" [matAutocomplete]="dataLabelAuto" required>
        <mat-autocomplete #dataLabelAuto="matAutocomplete" [displayWith]="dataItemListDisplayHelper" (optionSelected)="handleDataItemSelectorChange($event)">
            <mat-option *ngFor="let option of dataLabelListObservable | async" [value]="option">
                {{option.name}}
            </mat-option>
        </mat-autocomplete>
        <input class="form-control-input with-icon caption" type="text" matInput [formControl]="ruleSelector"  placeholder="{{ 'LABELS.RULE' | translate }}" [matAutocomplete]="rulesAuto" required>
        <mat-autocomplete #rulesAuto="matAutocomplete" [displayWith]="ruleDisplayFn">
            <mat-option *ngFor="let option of rulesListObservable | async" [value]="option">
                {{ ruleNameDisplayMap?.[option] || option | translate }}
            </mat-option>
        </mat-autocomplete>
        <input class="form-control-input caption" matInput  placeholder="{{ 'LABELS.VALUE' | translate }}" [formControl]="inputValueController">
    </div>
 </form>
 